import { render, staticRenderFns } from "./CmgOrderConfirmationPage.vue?vue&type=template&id=df48d4aa&scoped=true&lang=pug&"
import script from "./cmg-order-confirmation-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-confirmation-page.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df48d4aa",
  null
  
)

export default component.exports